import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { AuthService } from '@isophi/core-legacy';

@Component({
  selector: 'app-license-lock-modal',
  templateUrl: './license-lock-modal.component.html',
  styleUrls: ['./license-lock-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class LicenseLockModalComponent {
  private readonly authService = inject(AuthService);

  @Input() title = '';
  @Input() text = '';
  @Input() moduleKey = '';
  @Input() contained = false;

  readonly showPricingCta =
    !!this.authService.loggedUser?.teacher &&
    (this.authService.loggedUser.teacher.isDirector() || this.authService.loggedUser.teacher.isManager());
}
